export default {
  deleteLogo: 'watermark-logo-delete',
  position: 'watermark-position',
  opacity: 'watermark-opacity',
  delete: 'watermark-delete',
  rotate: 'watermark-rotate',
  size: 'watermark-size',
};
